var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M593.125 46.832C530.75 -15.549 429.25 -15.674 366.75 46.832S304.25 210.723 366.75 273.229C429.25 335.607 530.625 335.734 593.125 273.229S655.625 109.213 593.125 46.832ZM385.75 99.711L540.25 254.227C439.75 318.732 321 200.471 385.75 99.711ZM574.25 220.223L419.75 65.709C520.25 1.078 639 119.463 574.25 220.223ZM160 191.971C71.625 191.971 0 263.602 0 351.984S71.625 512 160 512S320 440.367 320 351.984S248.375 191.971 160 191.971ZM50.75 375.986H269.25C243.625 492.998 76.375 492.748 50.75 375.986ZM50.75 327.982C76.375 211.098 243.625 211.098 269.25 327.982H50.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablets);
export default __webpack_public_path__ + "static/media/tablets.ad7eaaeda408a52e2b0a862cee25abe9.svg";
export { ForwardRef as ReactComponent };